import {createStore} from 'vuex'

export default createStore({
    state: {
        activity: {},
        booking: {},
        filtres: {},
    },
    mutations: {
        updateActivity(state, payload) {
            state.activity = payload;
        },
        updateBooking(state, payload) {
            state.booking = payload;
        },
        updateFiltres(state, payload) {
            state.filtres = payload;
        }
    },
    getters: {
        getActivity: (state) => {
            return state.activity;
        },
        getBooking: (state) => {
            return state.booking;
        },
        getFiltres: (state) => {
            return state.filtres;
        }
    },
    actions: {},
    modules: {}
})
